import React from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import {Col} from 'reactstrap';
import 'pure-react-carousel/dist/react-carousel.es.css';
 
export default class Slideshow extends React.Component {
  render() {
    return (
        <Col xs='12' md={{size: 10, offset:1}} lg={{size:8, offset : 2}} xl={{size : 6, offset : 0}} >
            <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={125}
                totalSlides={3}
            >
                <Slider>
                <Slide index={0}>I am the first Slide.</Slide>
                <Slide index={1}>I am the second Slide.</Slide>
                <Slide index={2}>I am the third Slide.</Slide>
                </Slider>
                <ButtonBack>Back</ButtonBack>
                <ButtonNext>Next</ButtonNext>
            </CarouselProvider>
        </Col>
    );
  }
}
